<div class="row m-0 p-0" *ngIf="_gestionTercerosService.customerForm && !isLoadingTerceros">
    <app-modal-orders *ngIf="showModalOrders" [ordenesAbiCurCerr]="customerORList" [pantalla]="'gestion-terceros-register'" [tipo]="'cliente'"
        (childModalClose)="closeModalOrder($event)" [updateDetails]="updateDetails">
    </app-modal-orders>
    <div class="fondo-gris"
        *ngIf="showModalGeneric || showModalDownloadExcel || showModalPhone || showModalMail || showModalDesactivar || showModalDelete">
    </div>

    <app-modal-phone *ngIf="showModalPhone" [isModal]="true" [CustomerCodePhone]="CustomerCodePhone"
        [TelephonePortable]="TelephonePortable" [componentNumber]="menuChilds.GESTION_TERCEROS"
        (childModalClose)="closeModalPhone($event)">
    </app-modal-phone>

    <app-modal-mail *ngIf="showModalMail" [emailMessageData]="emailMessageData" [isModal]="true" [CustomerCodePhone]="CustomerCodePhone" (childModalClose)="closeModalMail($event)">
    </app-modal-mail>


    <app-generic-modal *ngIf="showModalGeneric" [title]="generic_title" [message]="generic_message"
        [textButtonOk]="generic_textButtonOk" [textButtonCancel]="generic_textButtonCancel" [aspa]="generic_aspa"
        [isButtonOk]="generic_isButtonOk" [isButtonCancel]="generic_isButtonCancel"
        (modalClose)="closeModalGeneric($event)" [popupName]="generic_popupName">
    </app-generic-modal>


    <app-desactivar-customer-modal *ngIf="showModalDesactivar" [title]="'titulos.GEN_TERCEROS'" [textButtonOk]="'Si'"
        [textButtonCancel]="'No'" [aspa]="false" [message]="'question.areYouSureClient'" [isButtonOk]="true"
        [isButtonCancel]="true" [dataCustomer]="dataCustomer" (modalClose)="closeModalDesactivar($event)">
    </app-desactivar-customer-modal>

    <app-delete-customer-modal *ngIf="showModalDelete" [title]="'titulos.GEN_TERCEROS'" [textButtonOk]="'si'"
        [textButtonCancel]="'no'" [aspa]="false" [message]="'genericos.toastr.citDelUsuario'" [isButtonOk]="true"
        [isButtonCancel]="true" [dataCustomer]="dataCustomer" (modalClose)="closeModalDelete($event)">
    </app-delete-customer-modal>

    <download-excel *ngIf="showModalDownloadExcel" [dfichero]='dfichero' [file]='file'
        (modalClose)="closeModalDownloadExcel($event)">
    </download-excel>



    <div class=" float-left"
        [ngClass]="{
        'col-xl-9 col-9': gestionTerceros || voClientes || gestionArticulos || _Facturas,
        'col-xl-12 col-12 reset': gestionOr || _Almacen || Taller_recepcionVehiculos || facturacionManual || entradasAlmacen || gestionArticulos || dossierVenta || facturacionRecibida }">
        <section>
            <form [formGroup]="_gestionTercerosService.customerForm">
                <div class="row" formGroupName="datosPrincipales">

                    <div class="formInit_terceros p-1">
                        <div class="row">
                            <div class="col-xl-8 col-md-7 col-sm-8">
                                <div class="row ml-1 altura1_7">

                                    <div class="col-5 m-0 p-1">

                                        <!-- Lamparita código cliente -->
                                        <div class="popoverClassic popoverClassic_1" *ngIf="activarLamparita">
                                            <button appCurrentColor class="btn-toolbar intoTable pos_0"
                                                popoverPlacement="bottom" [popoverOnHover]="false"
                                                [popoverCloseOnClickOutside]="true" [popover]="myPopover1"
                                                role="button">
                                                <i class="fa fa-lightbulb-o"></i>
                                            </button>

                                            <popover-content #myPopover1 [closeOnClickOutside]="true">
                                                <div class="body-tooltip popover_mod_1 mod1">
                                                    <span
                                                        [innerHtml]=" 'gestion_terceros.popover.cliente' | translate | returnHtml: 'html' "></span>
                                                </div>
                                            </popover-content>
                                        </div>

                                        <div class="form-group  datos_identificacion"
                                            [ngClass]="{'only_reading':!_gestionTercerosService.newCustomer }">
                                            <label title="{{ 'labels.cod_cliente' | translate }}"
                                                class="mt-1 pix_70  text-not-over text-right">{{ "labels.cod_cliente"
                                                | translate }}
                                                :
                                            </label>
                                            <input maxlength="6" formControlName="CustomerCode" type="text" numeric [decimals]="0"
                                                class=" anchurax40  float-right d-inline form-control"
                                                [ngClass]="{'form-error': _gestionTercerosService.customerForm.get('datosPrincipales').get('CustomerCode').invalid}" />
                                        </div>

                                    </div>

                                    <!-- Solo Caso ESPAÑA -->
                                    <div *ngIf="pais === 'es'|| pais === 'fr' "
                                        class="col-4 m-0 p-1 form-group_terceros datos_identificacion altura1_7">
                                        <kendo-dropdownlist [data]="documentos" [textField]="'Description'"
                                            [valueField]="'TypeCode'" [valuePrimitive]="true"
                                            [popupSettings]="{ width: 300 }" formControlName="IdentificationType"
                                            (valueChange)="idTypeChange($event)">
                                            <ng-template kendoDropDownListItemTemplate let-dataItem>
                                                <span class="kendo_list_template">{{ dataItem.Description }}</span>
                                            </ng-template>
                                        </kendo-dropdownlist>
                                    </div>

                                    <!-- ESPAÑA -->
                                    <div *ngIf="pais === 'es'" [ngClass]="{
                                        'popoverClassic_blue':  comprobarFiscalErrores() === 2,
                                        'popoverClassic_red':  comprobarFiscalErrores() === 3
                                        }" class="col-3  m-0 p-1 form-group altura1_7">
                                        <input [popoverOnHover]="true" [popover]="myPopover5"
                                            (blur)="blurElementDatosPrincipales('fiscalCode');blurFiscalCode();"
                                            placeholder="{{placeholderfiscalCode}}" maxLength="16" [ngClass]="{
                                                'form-error': comprobarFiscalErrores() === 1 || comprobarFiscalErrores() === 3 ,
                                                'form-no-valid' : comprobarFiscalErrores() === 2
                                            }" formControlName="fiscalCode" type="text" class="form-control" />
                                        <popover-content #myPopover5>
                                            <div class="body-tooltip" *ngIf="comprobarFiscalErrores() === 2">
                                                <span
                                                    [innerHtml]="'errors.required.formatoErroneo' | translate | returnHtml: 'html'"></span>
                                            </div>
                                            <div class="body-tooltip" *ngIf="comprobarFiscalErrores() === 3 ">
                                                <span
                                                    [innerHtml]="'errors.required.fiscalRepe' | translate | returnHtml: 'html'"></span>
                                            </div>
                                        </popover-content>
                                    </div>

                                    <!-- FRANCIA -->
                                    <div *ngIf="pais === 'fr' " class="col-3  m-0 p-1 form-group altura1_7" [ngClass]="{
                                        'popoverClassic_red':  comprobarFiscalErrores() === 3,
                                        'popoverClassic_blue': comprobarFiscalErrores() === 2}">
                                        <input (blur)="blurElementFiscalCodeFrance();blurElementDatosPrincipales('fiscalCode');blurFiscalCode();"
                                            placeholder="{{ placeholderfiscalCodeFrance }}" maxLength="16"
                                            formControlName="fiscalCode" type="text" class="form-control"
                                            [popoverOnHover]="true" [popover]="myPopoverFcFr"
                                            [ngClass]="{
                                                'form-error': comprobarErroresFrance() === 1 || comprobarFiscalErrores() === 3 ,
                                                'form-no-valid' : comprobarFiscalErrores() === 2
                                            }"/>
                                        <popover-content #myPopoverFcFr>
                                            <div class="body-tooltip" *ngIf="comprobarFiscalErrores() === 2">
                                                <span
                                                    [innerHtml]="'errors.required.formatoErroneo' | translate | returnHtml: 'html'"></span>
                                            </div>
                                            <div class="body-tooltip" *ngIf="comprobarFiscalErrores() === 3 ">
                                                <span
                                                    [innerHtml]="'errors.required.fiscalRepe' | translate | returnHtml: 'html'"></span>
                                            </div>
                                        </popover-content>
                                    </div>

                                    <!-- PORTUGAL -->
                                    <div *ngIf="pais === 'pt'" class="col-7  m-0 p-1 form-group altura1_7" [ngClass]="{
                                        'popoverClassic_red':  comprobarFiscalErrores() === 3,
                                        'popoverClassic_blue': comprobarFiscalErrores() === 2,
                                        'only_reading':checkNifPt()===true }">
                                        <label title="{{ 'gestion_terceros.identificationData.CFiscal' | translate }}"
                                            class="text-right mt-1 inline text-not-over" [ngClass]="{ 'pix_90':_small,
                                            'pix_120':!_small }">
                                            {{ 'gestion_terceros.identificationData.CFiscal' | translate }} :
                                        </label>
                                        <input [popoverOnHover]="true" [popover]="myPopover6"
                                            (blur)="blurElementDatosPrincipales('fiscalCode');blurFiscalCode();"
                                            placeholder="{{placeholderfiscalCode}}" maxLength="16" [ngClass]="{
                                                'form-error': comprobarFiscalErrores() === 1 || comprobarFiscalErrores() === 3 ,
                                                'form-no-valid' : comprobarFiscalErrores() === 2
                                            }" formControlName="fiscalCode" type="text" class="form-control anchurax40 float-right" />
                                        <popover-content #myPopover6>
                                            <div class="body-tooltip" *ngIf="comprobarFiscalErrores() === 2">
                                                <span
                                                    [innerHtml]="'errors.required.formatoErroneo' | translate | returnHtml: 'html'"></span>
                                            </div>
                                            <div class="body-tooltip" *ngIf="comprobarFiscalErrores() === 3 ">
                                                <span
                                                    [innerHtml]="'errors.required.fiscalRepe' | translate | returnHtml: 'html'"></span>
                                            </div>
                                        </popover-content>
                                    </div>


                                </div>

                                <div class="row altura1_7">
                                    <div class="col-12">
                                        <div class="row ml-1">
                                            <div class=" col-6  p-1 form-group datos_identificacion altura1_7">
                                                <label title="{{'labels.tratamiento' | translate}}"
                                                    class="pix_70 text-right mt-1 inline">
                                                    {{ "labels.tratamiento" | translate }} :
                                                </label>
                                                <kendo-dropdownlist (valueChange)="newTratamiento($event)"
                                                    id="tratamiento" [data]="courtesies" [textField]="'Description'"
                                                    [valueField]="'ID'" [valuePrimitive]="true"
                                                    [popupSettings]="{ width: 150 }" formControlName="tratamiento"
                                                    class="anchurax50">
                                                    <ng-template kendoDropDownListItemTemplate let-dataItem>
                                                        <span class="kendo_list_template">{{ dataItem.Description
                                                            }}</span>
                                                    </ng-template>
                                                </kendo-dropdownlist>
                                            </div>
                                            <!-- Name normal INI -->
                                            <div class=" col-6 m-0 p-1 form-group datos_identificacion altura1_7"
                                                *ngIf="cliente && !Taller_recepcionVehiculos">
                                                <label title="{{'labels.name' | translate}}"
                                                    class="mt-1 pix_50  text-right">{{ "labels.name" | translate
                                                    }}
                                                    :</label>
                                                <input maxlength="50" formControlName="CustomerName"
                                                    (blur)="blurElementDatosPrincipales('CustomerName')"
                                                    placeholder="{{placeholderCustomerName}}"
                                                    [ngClass]="{ 'form-error': getValueControl('CustomerName') }"
                                                    type="text" class="form-control inline anchurax65 float-right" />
                                            </div>
                                            <!--  Name normal FIN-->


                                            <!-- Con lupa Opcion B autocompletar-->
                                            <div class=" col-6 m-0 p-1 form-group datos_identificacion autocompleted_1 altura1_7"
                                                *ngIf="cliente && Taller_recepcionVehiculos">
                                                <label title="{{'labels.name' | translate}}"
                                                    class="mt-1 pix_70 text-right">{{ "labels.name" | translate
                                                    }}
                                                    :</label>
                                                <p-autoComplete [ngClass]="{
                                                        'form-error': getValueControl('CustomerName'),
                                                          'iconoInteriorSearch': siVacio('CustomerName')
                                                        }" inputStyleClass="form-control inline float-right"
                                                    styleClass="custom" formControlName="CustomerName"
                                                    (onSelect)="setSelectedName($event)"
                                                    (completeMethod)="search($event)" [suggestions]="dataCustomers"
                                                    class="antes float-right" styleClass="iconoInteriorSearch"
                                                    maxlength="50">
                                                    <ng-template let-item pTemplate="item">
                                                        {{item.CustomerName}}
                                                    </ng-template>
                                                </p-autoComplete>
                                            </div>
                                            <!-- Con lupa Opcion B autocompletar-->

                                        </div>
                                    </div>
                                </div>

                                <div class="row altura1_7">
                                    <div class="col-12">
                                        <div class="row ml-1">
                                            <!-- apellido 1 -->
                                            <div class=" col-6 m-0 p-1 form-group datos_identificacion altura1_7"
                                                *ngIf="cliente">
                                                <label title="{{'labels.apellido1' | translate}}"
                                                    class="mt-1 pix_70 text-right">
                                                    {{ "labels.apellido1" | translate }} : </label>

                                                <input
                                                    [ngClass]="{  'form-error': getValueControl('customerSurnameFirst') }"
                                                    (blur)="blurElementDatosPrincipales('customerSurnameFirst')"
                                                    placeholder="{{placeholdercustomerSurnameFirst}}" maxlength="50"
                                                    formControlName="customerSurnameFirst" type="text"
                                                    class="form-control inline anchurax50 " />
                                            </div>
                                            <!-- apellido 2 -->
                                            <div class=" col-6 m-0 p-1 form-group datos_identificacion altura1_7"
                                                *ngIf="cliente">
                                                <label title="{{ 'labels.apellido2' | translate }}"
                                                    class="pix_70 text-right mt-1 text-not-over text-nowrap">{{
                                                    "labels.apellido2" | translate }}
                                                    :</label>
                                                <input maxlength="50" formControlName="customerSurnameSecond"
                                                    type="text" class="form-control inline anchurax50 float-right" />
                                            </div>

                                            <div class="col-12 reset form-group datos_identificacion altura1_7"
                                                *ngIf="empresa  && !Taller_recepcionVehiculos">
                                                <label title="{{'labels.razonSocial' | translate }}"
                                                    class="pix_70 text-right mt-1 text-not-over text-nowrap">{{
                                                    "labels.razonSocial" | translate }}
                                                    :</label>
                                                <input maxlength="50"
                                                    [ngClass]="{  'form-error': getValueControl('CustomerName') }"
                                                    (blur)="blurElementDatosPrincipales('CustomerName')"
                                                    placeholder="{{placeholderCustomerName}}"
                                                    formControlName="CustomerName" type="text"
                                                    class="form-control inline anchurax70 mt-1" />
                                            </div>
                                            <!-- Recepcion de vehiculos  -->
                                            <div class="col-12 m-0 p-1 form-group datos_identificacion autocompleted_2 altura1_7"
                                                *ngIf="empresa && Taller_recepcionVehiculos">

                                                <label title="{{ 'labels.razonSocial' | translate }}"
                                                    class="pix_70 text-right mt-1 text-not-over">
                                                    {{ "labels.razonSocial" | translate }} :</label>

                                                <p-autoComplete
                                                    [ngClass]="{  'form-error iconoInteriorSearch': getValueControl('CustomerName') }"
                                                    (blur)="blurElementDatosPrincipales('CustomerName')"
                                                    placeholder="{{placeholderCustomerName}}"
                                                    inputStyleClass="form-control inline" styleClass="custom"
                                                    formControlName="CustomerName" (onSelect)="setSelectedName($event)"
                                                    (completeMethod)="search($event)" [suggestions]="dataCustomers"
                                                    class="antes" styleClass="iconoInteriorSearch" maxlength="150">
                                                    <ng-template let-item pTemplate="item">
                                                        {{item.CustomerName}}
                                                    </ng-template>
                                                </p-autoComplete>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                                <div class="row altura1_7 mb-2">
                                    <div class="col-12">
                                        <div class="row ml-1">
                                            <!-- autonomo -->
                                            <div class=" col-6 m-0 p-1 form-group datos_identificacion altura1_7"
                                                *ngIf="cliente">
                                                <label title="{{ 'labels.autonomo' | translate }}"
                                                    class="pix_70 text-right mt-1 text-not-over text-nowrap">{{
                                                    "labels.autonomo" | translate }}
                                                    :</label>
                                                <input (change)="changeAutonomo()" formControlName="customerSelfEmployed" type="checkbox" (change)="blurElementDatosPrincipales('customerBussinesName')" />
                                            </div>

                                            <!-- razon social -->
                                             <div class=" col-6 m-0 p-1 form-group datos_identificacion altura1_7"
                                                *ngIf="cliente">
                                                <label title="{{ 'labels.razonSocial' | translate }}"
                                                    class="pix_70 text-right mt-1 text-not-over text-nowrap">{{
                                                    "labels.razonSocial" | translate }}
                                                    :</label>
                                                <input placeholder="{{placeholdercustomerBussinesName}}"
                                                       formControlName="customerBussinesName"
                                                       type="text"
                                                       (blur)="blurElementDatosPrincipales('customerBussinesName')"
                                                       class="form-control inline anchurax50 float-right" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-xl-4 col-md-5 p-1 col-sm-4">
                                <div class="infoClient_terceros">
                                    <ul>
                                        <li>
                                            <p class="reset">
                                                {{ "labels.telefonoMovil" | translate
                                                }}:
                                                <span (click)="openModalPhone()" class="color_blue text-bold"
                                                    *ngIf="TelephonePortable">
                                                    <i class="fa fa-mobile fa-lg color_blue mr-1 "
                                                        aria-hidden="true"></i>{{ TelephonePortable }}
                                                </span>
                                            </p>
                                        </li>
                                        <li>
                                            <p class="reset">
                                                {{ "labels.telefonoFijo" | translate
                                                }}:
                                                <span class="text-bold" *ngIf="telefonofijo">
                                                    <i class="fa fa-phone mr-1" aria-hidden="true"></i>{{ telefonofijo
                                                    }}</span>
                                            </p>
                                        </li>
                                        <li>
                                            <p class="reset">
                                                {{ "labels.email" | translate}}:
                                                <span (click)="openModalMail()" class="color_blue  text-bold"
                                                    *ngIf="emailPara">
                                                    <i class="fa fa-mobile fa-lg mr-1 color_blue"
                                                        aria-hidden="true"></i>
                                                    {{ emailPara }} </span>
                                            </p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <!-- Lamparita Tabla -->
                        <div class="popoverClassic popoverClassic_1" *ngIf="activarLamparita">
                            <button appCurrentColor class="btn-toolbar pos_1" popoverPlacement="bottom"
                                [popoverOnHover]="false" [popoverCloseOnClickOutside]="true" [popover]="myPopover2"
                                role="button">
                                <i class="fa fa-lightbulb-o"></i>
                            </button>

                            <popover-content #myPopover2 [closeOnClickOutside]="true">
                                <div class="body-tooltip popover_mod_1 mod1">
                                    <span [innerHtml]="
                                'gestion_terceros.popover.navegar'
                                  | translate
                                  | returnHtml: 'html'"></span>
                                </div>
                            </popover-content>
                        </div>
                    </div>

                    <!-- Section2 Pestañas -->
                    <div class="col-12" id="gestion_terceros">

                        <div class="row">

                            <div class="manejadores reset" *ngIf="conManejadores">
                                <span class="k-icon k-i-arrow-chevron-right" (click)="derecha()"></span>
                            </div>

                            <div [ngClass]="
                      { 'col-12': col12 ,
                        'col-11': col11,
                        'reset':resetear,
                        'sin_manejadores': sinManejadores,
                        'con_manejadores': conManejadores,
                        'altura_pestanas_big':gestionTerceros,
                        'altura_pestanas_small':!gestionTerceros
                      }" #tabstripCarrousel>


                                <kendo-tabstrip (tabSelect)="onTabSelect($event)">
                                    <kendo-tabstrip-tab [disabled]="!showDatosIdentificacion" [selected]="tab === 0"
                                        [title]="'labels.datosIdentif' | translate" #primerLi>
                                        <ng-template kendoTabContent>

                                            <div [ngClass]=" {'contenedor_pestana_big':gestionTerceros, 'contenedor_pestana_small':!gestionTerceros}"
                                                class="" id="identificacion">
                                                <app-identification-data [cargarVista]="cargarVista"
                                                    [modoEdicion]="modoEdicion">
                                                </app-identification-data>
                                            </div>

                                        </ng-template>
                                    </kendo-tabstrip-tab>
                                    <!-- -->
                                    <kendo-tabstrip-tab [disabled]="!showDatosContacto"
                                        [title]="'labels.datosContact' | translate" [selected]="tab === 1">
                                        <ng-template kendoTabContent>
                                            <div id="contacto"
                                                [ngClass]=" { 'contenedor_pestana_big':gestionTerceros, 'contenedor_pestana_small':!gestionTerceros }">
                                                <app-contact-information (excel)="downExcel($event)"
                                                    [formMode]="formMode" [modoEdicion]="modoEdicion"
                                                    [dataCustomer]="dataCustomer">
                                                </app-contact-information>
                                            </div>
                                        </ng-template>
                                    </kendo-tabstrip-tab>
                                    <kendo-tabstrip-tab [disabled]="!showContactos"
                                        [title]="'labels.contacts' | translate" [selected]="tab === 2">
                                        <ng-template kendoTabContent>
                                            <div id="contactos"
                                                [ngClass]="{  'contenedor_pestana_big':gestionTerceros, 'contenedor_pestana_small':!gestionTerceros}">
                                                <app-contacts [formMode]="formMode" [customerId]="customerId"
                                                    [modoEdicion]="modoEdicion">
                                                </app-contacts>
                                            </div>
                                        </ng-template>
                                    </kendo-tabstrip-tab>
                                    <!--   *ngIf="!voClientes"-->
                                    <kendo-tabstrip-tab [disabled]="!showGestion" [selected]="tab === 3"
                                        [title]="'labels.gestion' | translate">
                                        <ng-template kendoTabContent>
                                            <div id="gestion"
                                                [ngClass]="{'contenedor_pestana_big':gestionTerceros,  'contenedor_pestana_small':!gestionTerceros}">
                                                <app-gestion [formMode]="formMode" [modoEdicion]="modoEdicion">
                                                </app-gestion>
                                            </div>
                                        </ng-template>
                                    </kendo-tabstrip-tab>
                                    <kendo-tabstrip-tab [disabled]="!showVehiculos"
                                        [title]="'labels.vehiculos' | translate" [selected]="tab === 4">
                                        <ng-template kendoTabContent>
                                            <div id="vehicles"
                                                [ngClass]=" { 'contenedor_pestana_big':gestionTerceros,'contenedor_pestana_small':!gestionTerceros }">
                                                <app-tab-vehicles [cargarVista]="cargarVista" [formMode]="formMode"
                                                    [modoEdicion]="modoEdicion" [readonlyMode]="isModal">
                                                </app-tab-vehicles>
                                            </div>
                                        </ng-template>
                                    </kendo-tabstrip-tab>
                                    <!-- [selected]="tab === 5"  *ngIf="!_gestionTercerosService.newCustomer "-->
                                    <kendo-tabstrip-tab [disabled]="!showComunicaciones"
                                        [title]="'labels.comunicaciones' | translate" [selected]="tab === 5">
                                        <ng-template kendoTabContent>
                                            <div [ngClass]="  {  'contenedor_pestana_big':gestionTerceros,  'contenedor_pestana_small':!gestionTerceros }"
                                                class="" id="communications">
                                                <app-communications [formMode]="formMode" [modoEdicion]="modoEdicion">
                                                </app-communications>
                                            </div>
                                        </ng-template>
                                    </kendo-tabstrip-tab>


                                    <!-- [selected]="tab === 6" *ngIf="pais == 'es'"-->
                                    <kendo-tabstrip-tab [disabled]="!showCentros"
                                        [title]="'labels.centros_administrativos' | translate" [selected]="tab === 6">
                                        <ng-template kendoTabContent>
                                            <div [ngClass]="
                                                    {
                                                    'contenedor_pestana_big':gestionTerceros,
                                                    'contenedor_pestana_small':!gestionTerceros
                                                    }" class="" id="centros">
                                                <app-administrative-centers [formMode]="formMode"
                                                    [modoEdicion]="modoEdicion">
                                                </app-administrative-centers>
                                            </div>
                                        </ng-template>
                                    </kendo-tabstrip-tab>
                                </kendo-tabstrip>
                            </div>

                            <div class="manejadores reset" *ngIf="conManejadores">
                                <span class="k-icon k-i-arrow-chevron-left" (click)="izquierda()"></span>
                            </div>



                        </div>

                    </div>
                </div>
            </form>
        </section>

    </div>

    <!-- BOTONES DERECHA solo para gestionTerceros-->
    <div class="col-xl-3 col-3 m-0 p-1 float-left" *ngIf="gestionTerceros || voClientes || _Facturas">

        <div class="popoverClassic popoverClassic_2" *ngIf="activarLamparita">
            <button appCurrentColor class="btn-toolbar intoTable pos_0" popoverPlacement="bottom"
                [popoverOnHover]="false" [popoverCloseOnClickOutside]="true" [popover]="myPopover3" role="button">
                <i class="fa fa-lightbulb-o"></i>
            </button>
            <popover-content #myPopover3 [closeOnClickOutside]="true">
                <div class="body-tooltip popover_mod_1 mod2">
                    <span [innerHtml]="
                  'gestion_terceros.popover.guardar'
                    | translate
                    | returnHtml: 'html' "></span>
                </div>
            </popover-content>
        </div>

        <div class="contenedor-div border-0 ">

            <button *ngIf="!_gestionTercerosService.newCustomer && _gestionTercerosService.botonGuardar" type="button"
                [disabled]="_gestionTercerosService.customerForm.invalid || comprobarFiscalErrores() !== 0 || isModal" (click)="guardarDatos()"
                class="btn btn-secondary btn-block text-left mb-1">
                {{ "labels.guardar_cambios" | translate }}
                <span class="k-icon k-i-save k-i-floppy float-right color_white"></span>
            </button>

            <button *ngIf="_gestionTercerosService.newCustomer && _gestionTercerosService.botonGuardar" type="button"
                [disabled]="_gestionTercerosService.customerForm.invalid || comprobarFiscalErrores() !== 0 || isModal" (click)="anadirDatos()"
                class="btn btn-secondary btn-block text-left mb-1 mt-0">
                {{ "labels.guardar_cambios" | translate }}
                <span class="k-icon k-i-save k-i-floppy float-right color_white"></span>
            </button>


            <!-- el boton de reactivar -->
            <button *ngIf="_gestionTercerosService.botonReactivar || formMode" type="button" (click)="reactivar()"
                class="btn btn-secondary btn-block text-left mt-0 mb-1 " [disabled]="isModal">
                {{ "labels.reactivar" | translate }}
                <span class="k-icon k-i-plus-circle float-right color_white"></span>
            </button>

            <!-- Se puede dar de baja -->
            <button type="button" [disabled]="!_gestionTercerosService.sePuedeDesactivar || formMode || isModal"
                (click)="desactivarCustomer()" class="btn btn-secondary btn-block text-left mt-0 mb-1 ">
                {{ "labels.baja" | translate }}
                <span class="k-icon k-i-plus-circle float-right color_white"></span>
            </button>

            <!-- Borrar cliente -->
            <button type="button"
                [disabled]="!_gestionTercerosService.puedeBorrarse || _gestionTercerosService.statusBA || formMode || isModal"
                (click)="deleteCustomer()" class="btn btn-secondary btn-block text-left mt-0 mb-1 ">
                {{ "labels.deleteClient" | translate }}
                <span class="k-icon k-i-delete float-right color_white"></span>
            </button>

            <!-- Recuperar cliente-->
            <button *ngIf="isRsdAdmin" type="button" [disabled]="!_gestionTercerosService.statusBA || formMode || isModal"
                (click)="undeleteCustomer()" class="btn btn-secondary btn-block text-left mt-0 mb-1 ">
                {{ "labels.recuperar_cliente" | translate }}
                <span class="k-icon k-i-undo float-right color_white"></span>
            </button>
        </div>

        <!-- CAJA INFO -->
        <information-box [textoBox]="textoBox"> </information-box>
    </div>
</div>

<div *ngIf="isLoadingTerceros" class="kendo-loading" [style.height.px]="350">
    <span appCurrentColor class="k-icon k-i-loading big"></span>
</div>

<div class="row reset"
    *ngIf="(_Almacen || ventaVo || Taller_recepcionVehiculos || facturacionManual || entradasAlmacen || gestionArticulos || dossierVenta || facturacionRecibida) && _gestionTercerosService.customerForm">
    <div class="col-12">
        <button type="button" (click)="cancelarOut()" class="btn btn-secondary to-left">
            <i class="fa fa-ban" aria-hidden="true"> </i>
            {{'labels.cancelar' | translate}}
        </button>
        <button type="button" (click)="anadirDatosExterno()" class="btn btn-secondary to-rigth ">
            <span>{{'labels.anadir' | translate}}</span>
            <!-- <span *ngIf="!facturacionManual ">{{'labels.anadir_vehiculo' | translate}}</span> -->
            <i class="fa fa-plus-circle" aria-hidden="true">
            </i>
        </button>
    </div>

</div>

<div class="row reset" *ngIf="presupuestosTaller">
    <div class="col-12">
        <button type="button" (click)="cancelarOut()" class="btn btn-secondary to-left">
            <i class="fa fa-ban" aria-hidden="true"> </i>
            {{'labels.cancelar' | translate}}
        </button>
        <button type="button"
            [disabled]="!_gestionTercerosService.customerForm || _gestionTercerosService.customerForm.invalid"
            (click)="anadirDatosExterno()" class="btn btn-secondary to-rigth ">
            <span>{{'labels.anadir_vehiculo' | translate}}</span>
            <i class="fa fa-plus-circle" aria-hidden="true">
            </i>
        </button>
    </div>

</div>
